import React from 'react';
import { useTranslation } from 'react-i18next';

import Svg from 'src/components/Svg';
import { DEFAULT_SMILEY_RATING } from 'src/components/SurveyDashboard/constants';
import s from 'src/components/SurveyDashboard/SurveyDashboard.styles';
import { SurveyStatisticsPropTypes } from 'src/components/SurveyDashboard/propTypes';

const SurveyDashboardQuestionCharts = ({ surveySummary }) => {
  const { t } = useTranslation();
  const { responseStatistics } = surveySummary;

  const getBgColor = (optionStats, responsePercent) => {
    const value = optionStats.reduce((a, b) => Math.max(a.responsePercent > b.responsePercent) ? a : b);
    return ( value.responsePercent > responsePercent ) ? 'var(--ph-gray-600)' : 'var(--ph-light-blue-600)';
  };

  const getIcon = (rs, index) => {
    
    if(rs.questionType === 'smileyRating') {
      return <s.SmileyIcon name={DEFAULT_SMILEY_RATING[index]} />;
    } 
    const stars = [...Array(index + 1).keys()];
    return stars.map((v, i)=> <s.StarIcon name="question-type-star-rating" key={`stars-${rs.datasheetQuestionId}-${i}`}/> );
  };

  const isSmileyOrStarQuestion = (questionType) => {
    return (questionType === 'smileyRating' || questionType === 'starRating');
  };

  return (
    <> 
      {responseStatistics.map((rs, i)=> {
        return (
          <s.Container key={`question-${rs.datasheetQuestionId}-${i}`}>
            <s.QuestionText>{rs.questionNumber}. { rs.text }</s.QuestionText>
            <s.TableWrapper>
              <s.Table>
                <thead>
                  <tr>
                    <th>{ t('ANSWER') }</th>
                    <th>{ t('COUNT') }</th>
                    <th>{ t('PERCENT') }</th>
                    <th>
                      <table>
                        <thead>
                          <tr>
                            <td>{ t('20%') }</td>
                            <td>{ t('40%') }</td>
                            <td>{ t('60%') }</td>
                            <td>{ t('80%') }</td>
                            <td>{ t('100%') }</td>
                          </tr>
                        </thead>
                      </table>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rs.optionStats?.map((os, index)=> {
                    return (
                      <tr key={`row-${rs.datasheetQuestionId}-${index}`}>
                        <td className={isSmileyOrStarQuestion(rs.questionType) ? (s.Classes.icon) : ''}>
                          { isSmileyOrStarQuestion(rs.questionType) && getIcon(rs, os.optionIndex) }
                          <p>{os.option}</p>
                        </td>
                        <td>{os.responseCount}</td>
                        <td>{os.responsePercent}%</td>
                        <td>
                          <table cellSpacing="0">
                            <tbody>
                              <tr>
                                <td style={{backgroundColor:`${getBgColor(rs.optionStats, os.responsePercent)}`, width: `${os.responsePercent}%`}}>
                                </td>
                                <td style={{backgroundColor:'transparent', width: `${100 - os.responsePercent}%`}}>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  )}
                </tbody>
                <tfoot>
                  {rs.optionStats.length ? (
                    <tr>
                      <td>{ t('TOTAL') }</td>
                      <td>{rs.numberOfResponses}</td>
                      { (rs.numberOfResponses > 0) ? <td>{ t('100%') }</td> : <td>{ t('0%') }</td> }
                      <td/>
                    </tr>) : <tr></tr>
                  }
                </tfoot>
              </s.Table>
            </s.TableWrapper>
          </s.Container>
        )}
      )}
    </>
  );
};

SurveyDashboardQuestionCharts.defaultProps = SurveyStatisticsPropTypes;

export default React.memo(SurveyDashboardQuestionCharts);
